import { Flex } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { Widget } from 'src/dashboard/components/Widgets/Widget'
import { useActions } from 'src/hooks'
import {
  useDigitalCardsReceived,
  useDigitalGiftCardProducts,
} from 'src/react_query'
import moment from 'moment'
import { GiftCardsLineItem } from './GiftCardsLineItem'

type GiftCardsWidgetProps = {}

export const GiftCardsWidget: React.FC<GiftCardsWidgetProps> = () => {
  const actions = useActions()

  const { data, isFetching } = useDigitalCardsReceived({
    first: 5,
    filters: {
      hasGiftCard: true,
    },
  })

  const gifts = data?.pages
    .flatMap(page =>
      page!.edges.map(edge => {
        return edge.node.recipients[0].giftCards.map(gc => ({
          ...gc,
          expiresAt: edge.node.expiresAt
            ? moment(edge.node.expiresAt).format('MM/DD/YY')
            : '',
          actFrontImgUrl: edge.node.card.frontPreviewUrl,
          sentDate: moment(new Date(edge.node.card.updatedAt)).format(
            'MM/DD/YY',
          ),
          sender: `${edge.node.recipients[0].sender.firstName} ${edge.node.recipients[0].sender.lastName}`,
          token: edge.node.recipients[0].token,
        }))
      }),
    )
    .flat()

  const productQueries = useDigitalGiftCardProducts(
    gifts ? gifts.map(g => g.productCodes[0]) : [],
  )

  if (productQueries.length === 0) {
    return null
  }

  return (
    <Flex
      width="100%"
      css={{
        minHeight: '220px',
        display: 'grid',
      }}
    >
      <Widget
        alignment="start"
        minWidth="100%"
        isLoading={isFetching}
        isEmpty={!productQueries || productQueries.length === 0} // If results is 0
        header={{
          title: 'My Gift Cards',
          action: {
            title: 'View More',
            onClick: () => actions.openMyGifts(),
          },
        }}
        emptyState={{
          title: 'No Gift Cards',
          description: `You don't have any gift cards`,
          icon: 'drafts',
          contentMaxWidth: '480px',
          action: {
            title: 'Send a card today',
            onClick: () => actions.openCatalog(),
          },
        }}
      >
        <Flex flexDirection="column" width="100%">
          {productQueries.map((pq, i) => {
            if (pq.data && gifts && gifts[i]) {
              const gift = gifts[i]
              const giftCellData = {
                brand: pq.data.title,
                thumbnail: pq.data.image ?? '',
                from: gift.sender,
                currency: gift.currency,
                amount: `$${gift.amount.split('.')[0]}`,
              }
              return (
                <Flex width="100%" alignItems="flex-start">
                  <GiftCardsLineItem {...giftCellData} />
                </Flex>
              )
            }
            return null
          })}
        </Flex>
      </Widget>
    </Flex>
  )
}
